import { render } from "./slidesdb_chap05_en.vue?vue&type=template&id=aed8ab3e&scoped=true"
import script from "./slidesdb_chap05_en.vue?vue&type=script&lang=js"
export * from "./slidesdb_chap05_en.vue?vue&type=script&lang=js"

import "@/assets/css/globalen.css?vue&type=style&index=0&id=aed8ab3e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aed8ab3e"]])

export default __exports__